module.exports = __webpack_public_path__ + "static/media/LogoTopLeft.b2b739b6.png";